/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

import { $root } from '../../../player/player';
import PlaybackControls from '../../playback-controls/playback-controls';

// @ts-ignore Není to ESM.
import template from './content-overlay.html';

/**
 * @import { PropType } from 'vue'
 * @import { OverlayStyle } from '.'
 * @import { Content } from '../content'
 */

export default defineComponent({
  name: 'ContentOverlay',
  template,
  components: { PlaybackControls },
  emits: {},
  data() {
    return {
      touchStartX: undefined,
      touchStartY: undefined
    };
  },
  methods: {
    onTouchStart(e) {
      if (e.touches && e.touches.length === 1) {
        this.touchStartX = e.touches[0].clientX;
        this.touchStartY = e.touches[0].clientY;
      }
    },
    onTouchEnd(e) {
      if (
        e.changedTouches &&
        e.changedTouches.length === 1 &&
        this.touchStartX !== undefined &&
        this.touchStartY !== undefined
      ) {
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const dx = endX - this.touchStartX;
        const dy = Math.abs(endY - this.touchStartY);

        if (dx < -50 && dy < 30) {
          $root(this).playbackControlsEmitter.skip(this.content);
        }
        this.touchStartX = undefined;
        this.touchStartY = undefined;
      }
    }
  },
  props: {
    content: {
      /** @type {PropType<Content>} */ type: Object,
      required: true
    },
    overlayStyle: {
      /** @type {PropType<OverlayStyle>} */ type: Object,
      required: true
    },
    playbackControlsEnabled: {
      type: Boolean,
      required: true
    }
  }
});
